import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

export const getHomePageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true,
        about_video: true,
        missionvision_image: true,
        stats_image: true,
        brandlogos_images: true,
        sdg_image: true,
        team_australia: { populate: 'profile_image' },
        team_india: { populate: 'profile_image' },
        team_sri_lanka: { populate: 'profile_image' },
        benefits_list: { populate: '*' },
        sdg_list: { populate: '*' },
        stats_list: { populate: '*' },
        testimonials_list: { populate: '*' }
      }
    });
    
    const [homeRes, ausRes, indRes, slRes] = await Promise.all([
      strapi.get(`/home-page?${query}`),
      strapi.get('/team-members?populate=profile_image&pagination[limit]=100'),
      strapi.get('/team-indias?populate=profile_image&pagination[limit]=100'),
      strapi.get('/team-sri-lankas?populate=profile_image&pagination[limit]=100')
    ]);
    
    const data = mapStrapiData(homeRes);
    
    if (!data) return null;

    data.team_australia = mapStrapiData(ausRes) || [];
    data.team_india = mapStrapiData(indRes) || [];
    data.team_sri_lanka = mapStrapiData(slRes) || [];

    return data;
  } catch (error) {
    console.error('Home Page API Error:', error);
    return null;
  }
};
